type ExpectedData = Record<string, unknown>;

function resolvePath(obj: ExpectedData, path: string): unknown {
  return path
    .split(".")
    .reduce<unknown>(
      (acc, key) =>
        acc && typeof acc === "object" && key in acc
          ? (acc as Record<string, unknown>)[key]
          : undefined,
      obj
    );
}

export const strTemplateToStr = (str: string, data: ExpectedData, depth = 0): string => {
  if (depth > 10) return str;
  let replaced = str.replace(/\$\{([^}]+)\}/g, (_, keyPath: string) => {
    const val = resolvePath(data, keyPath.trim());
    return typeof val === "undefined" ? "" : String(val);
  });

  if (/\$\{/.test(replaced) && depth < 10) {
    return strTemplateToStr(replaced, data, depth + 1);
  }

  replaced = replaced.replace(/\s+/g, " ").trim();

  if (replaced === "" || /^\s*$/.test(replaced)) return "";

  return replaced;
};

function deepObjTemplate<T>(obj: T, data: ExpectedData): T {
  if (typeof obj === "string") {
    return strTemplateToStr(obj, data) as unknown as T;
  }
  if (Array.isArray(obj)) {
    return obj.map((item) => deepObjTemplate(item, data)) as unknown as T;
  }
  if (typeof obj === "object" && obj !== null) {
    const res: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(obj)) {
      res[k] = deepObjTemplate(v, data);
    }
    return res as T;
  }
  return obj;
}

export const objTemplateToObj = <T extends object>(obj: T, data: ExpectedData): T => {
  try {
    return deepObjTemplate(obj, data);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("objTemplateToObj", obj, data, e);
    return obj;
  }
};
